module.exports = __webpack_public_path__ + "static/media/img_ai_06.2d5689db.png";